
/* injects from baggage-loader */

'use strict';

import ProductController from './product.controller';
import ProductTemplate from './product-new.html';

export default class ProductComponent {
		constructor() {
				this.templateUrl = ProductTemplate;
				this.controller = ProductController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					ctx: '<'
				};
		}
}
